import { useSearchParams } from "infrastructure/router";
import { ReferrerStatus } from "./types";

export default function useReferrerStatus({ searchQueryParamName = 'status' } = {}) {
    const [searchQueryParams] = useSearchParams();

    return searchQueryParams.get(searchQueryParamName) as ReferrerStatus | null;
};
